import service from './service.js';

export default {
  search(data) {
    return service.execute('get', 'cercasentenze?' + service.encodeQueryData(data));
  },
  getTribunali() {
    return service.execute('get', 'cercasentenze/tribunali');
  },
  getMaterie(filter) {
    return service.execute('get', 'cercasentenze/materie?' + service.encodeQueryData(filter));
  }
}



// WEBPACK FOOTER //
// ./src/services/search.js